import { render, staticRenderFns } from "./RequestsDetail.vue?vue&type=template&id=5b516f19&"
import script from "./RequestsDetail.vue?vue&type=script&lang=js&"
export * from "./RequestsDetail.vue?vue&type=script&lang=js&"
import style0 from "./RequestsDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports